// ============================================================================
// @repo/shared — Barrel Exports
// ============================================================================

// Types (entity & UI)
export type {
  UserRole,
  Permission,
  User,
  UserAccount,
  MenuItem,
  AppModule,
  Setting,
  Party,
  Invoice,
  InvoiceDetails,
  InvoiceKind,
  AdvanceInvoiceRef,
  AdvanceOrder,
  InvoiceHistoryEntry,
  CorrectedInvoiceRef,
  CorrectionInvoice,
  CorrectionInvoiceDetails,
  KSeFRegistrationStatus,
  KSeFRegistration,
  KSeFEnvironment,
  KSeFCertificateInfo,
  ReceivedDocumentSummary,
  ReceivedDocumentItem,
  ReceivedDocumentHistoryEntry,
  ReceivedDocumentDetail,
  AppSetting,
  CompanySettings,
  DocumentPullSettings,
  ExternalSystemSettings,
  SessionLoopSettings,
  SessionLoopEnvSettings,
  SessionLoopLimits,
  KSeFSyncState,
  RawDataStructures,
  PartyExtended,
  RegistryInfo,
  ExtendedParameter,
} from "./types";

// API request/response DTOs
export type {
  LoginRequest,
  LoginResponse,
  SetupStatusResponse,
  SetupInitializeRequest,
  SetupInitializeResponse,
  InvoiceListRequest,
  InvoiceListResponse,
  PaginatedListResponse,
  InvoiceDetailsResponse,
  InvoiceHistoryResponse,
  KSeFRegisterResponse,
  InvoiceStatusCheckResponse,
  BatchStatusCheckResponse,
  UserListRequest,
  UserListResponse,
  UserGetResponse,
  CreateUserRequest,
  CreateUserResponse,
  UpdateUserRequest,
  UpdateUserResponse,
  DeleteUserResponse,
  KSeFEnvironmentGetResponse,
  KSeFEnvironmentSetRequest,
  KSeFEnvironmentSetResponse,
  UpdateCompanySettingsRequest,
  CompanySettingsGetResponse,
  CompanySettingsUpdateResponse,
  UpdateDocumentPullSettingsRequest,
  DocumentPullSettingsGetResponse,
  DocumentPullSettingsUpdateResponse,
  UpdateExternalSystemSettingsRequest,
  ExternalSystemSettingsGetResponse,
  ExternalSystemSettingsUpdateResponse,
  UpdateSessionLoopSettingsRequest,
  SessionLoopSettingsGetResponse,
  SessionLoopSettingsUpdateResponse,
  DocumentListRequest,
  DocumentListResponse,
  DocumentDetailResponse,
  DocumentXmlResponse,
  UpdateDocumentStatusRequest,
  CheckNewDocumentsResponse,
  DocumentPullResult,
  SyncStatusResponse,
  ResetSyncResponse,
  FullResetResponse,
} from "./api-types";

// Constants
export {
  API_ENDPOINTS,
  KSEF_ENVIRONMENTS,
  KSEF_ENVIRONMENT_OPTIONS,
  USER_ROLES,
  ROLE_LABELS,
  ADMIN_ROLES,
  KSEF_REGISTRATION_STATUSES,
  REGISTRATION_STATUS_LABELS,
  DOCUMENT_STATUSES,
  DOCUMENT_STATUS_LABELS,
  APP_SETTING_KEYS,
  DEFAULT_PAGE_SIZE,
  PAGE_SIZE_OPTIONS,
} from "./constants";

export type { ApiEndpoint, DocumentStatus, AppSettingKey } from "./constants";

// Menu data
export { menuItems } from "./menu-data";

// Auth store
export { useAuthStore, createAuthStore } from "./stores/auth-store";
export type { AuthUser, AuthState } from "./stores/auth-store";
